define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const config = require('config');
    const server = require('server');
    const serverUtil = require('util/server.util');
    const BaseModel = require('common/base.model');

    module.exports = BaseModel.extend({

        defaults: {
            birthCountries: []
        },

        /**
         * @param validityDate {string} format YYYY-MM-DD
         * @return {$.Deferred}
         */
        fetchCountries: function(validityDate) {
            return server.send({
                ID: 35896,
                description: 'Get Birth Countries Request',
                responses: [35897, 35898],
                validityDate
            }).then(response => response.data.birthCountries);
        },

        /**
         * @param validityDate {string} format YYYY-MM-DD
         * @param countryCode {string}
         * @return {$.Deferred}
         */
        fetchRegionsByCountryCode: function(validityDate, countryCode) {
            return server.send({
                ID: 35893,
                responses: [35894, 35895],
                description: 'Get Regions By Country Code',
                casino: config.get('casinoName'),
                countryCode,
                validityDate
            })
                .then(response => response.data.regionsByCountryCode)
                .fail(error => $.Deferred().reject(serverUtil.getErrorMessage(error)));
        },

        getProvinces: function() {
            const regionsByCountryCode = this.get('regionsByCountryCode');

            return regionsByCountryCode
                .map(region => region.provinces)
                .flat();
        },

        getSogeiRegionCode: function(provinceCode) {
            const regionsByCountryCode = this.get('regionsByCountryCode');

            const currentRegion = regionsByCountryCode
                .find(region => region.provinces.some(province => province.abbreviation === provinceCode));

            return currentRegion?.sogeiRegionCode;
        },

        getProvinceCities: function(provinceCode) {
            const regionsByCountryCode = this.get('regionsByCountryCode');

            return regionsByCountryCode
                .map(region => region.provinces)
                .flat()
                .filter(province => province.abbreviation === provinceCode)
                .map(province => province.cities)
                .flat();
        }
    });
});
